/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancelScheduledDowngradeResponse,
  GetApiV1SubscriptionStripeProrationParams,
  GetCancellationCouponHandler,
  GetCancellationReasonsResponse,
  GetSubscriptionResponse,
  GetSubscriptionStripeInvoiceResponse,
  GetSubscriptionStripeProrationResponse,
  PatchSubscriptionRequest,
  PauseSubscriptionRequest,
  PauseSubscriptionResponse,
  PostCouponRequest,
  PostCouponResponse,
  PostPromotionCodeRequest,
  PostPromotionCodeResponse,
  PostSubscriptionStripeRequest,
  PostSubscriptionStripeResponse,
  ProblemDetails,
  PutSubscriptionStripeCustomerRequest,
  PutSubscriptionStripeCustomerResponse,
  ResumeSubscriptionRequest,
  ResumeSubscriptionResponse,
  ScheduleDowngradeRequest,
  ScheduleDowngradeResponse
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1SubscriptionCancellationReasons = (

 signal?: AbortSignal
) => {


      return apiClient<GetCancellationReasonsResponse | null>(
      {url: `/api/v1/subscription/cancellation-reasons`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1SubscriptionCancellationReasonsQueryKey = () => {
    return [
    `/api/v1/subscription/cancellation-reasons`
    ] as const;
    }


export const getGetApiV1SubscriptionCancellationReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError = ProblemDetails | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SubscriptionCancellationReasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>> = ({ signal }) => getApiV1SubscriptionCancellationReasons(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SubscriptionCancellationReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>>
export type GetApiV1SubscriptionCancellationReasonsQueryError = ProblemDetails | null


export function useGetApiV1SubscriptionCancellationReasons<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError = ProblemDetails | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionCancellationReasons<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionCancellationReasons<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SubscriptionCancellationReasons<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationReasons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SubscriptionCancellationReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1SubscriptionSubscriptionId = (
    subscriptionId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetSubscriptionResponse | null>(
      {url: `/api/v1/subscription/${subscriptionId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1SubscriptionSubscriptionIdQueryKey = (subscriptionId: number,) => {
    return [
    `/api/v1/subscription/${subscriptionId}`
    ] as const;
    }


export const getGetApiV1SubscriptionSubscriptionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError = ProblemDetails | null>(subscriptionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SubscriptionSubscriptionIdQueryKey(subscriptionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>> = ({ signal }) => getApiV1SubscriptionSubscriptionId(subscriptionId, signal);





   return  { queryKey, queryFn, enabled: subscriptionId !== null && subscriptionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SubscriptionSubscriptionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>>
export type GetApiV1SubscriptionSubscriptionIdQueryError = ProblemDetails | null


export function useGetApiV1SubscriptionSubscriptionId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError = ProblemDetails | null>(
 subscriptionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionSubscriptionId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError = ProblemDetails | null>(
 subscriptionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionSubscriptionId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError = ProblemDetails | null>(
 subscriptionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SubscriptionSubscriptionId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError = ProblemDetails | null>(
 subscriptionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionSubscriptionId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SubscriptionSubscriptionIdQueryOptions(subscriptionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiV1SubscriptionSubscriptionId = (
    subscriptionId: number,
    patchSubscriptionRequestNull: PatchSubscriptionRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<GetCancellationCouponHandler | null>(
      {url: `/api/v1/subscription/${subscriptionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchSubscriptionRequestNull, signal
    },
      );
    }




export const getPatchApiV1SubscriptionSubscriptionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number;data: PatchSubscriptionRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number;data: PatchSubscriptionRequest | null}, TContext> => {

const mutationKey = ['patchApiV1SubscriptionSubscriptionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>, {subscriptionId: number;data: PatchSubscriptionRequest | null}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  patchApiV1SubscriptionSubscriptionId(subscriptionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1SubscriptionSubscriptionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>>
    export type PatchApiV1SubscriptionSubscriptionIdMutationBody = PatchSubscriptionRequest | null
    export type PatchApiV1SubscriptionSubscriptionIdMutationError = ProblemDetails | null

    export const usePatchApiV1SubscriptionSubscriptionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number;data: PatchSubscriptionRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1SubscriptionSubscriptionId>>,
        TError,
        {subscriptionId: number;data: PatchSubscriptionRequest | null},
        TContext
      > => {
      return useMutation(getPatchApiV1SubscriptionSubscriptionIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1SubscriptionSubscriptionId = (
    subscriptionId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetCancellationCouponHandler | null>(
      {url: `/api/v1/subscription/${subscriptionId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1SubscriptionSubscriptionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number}, TContext> => {

const mutationKey = ['deleteApiV1SubscriptionSubscriptionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>, {subscriptionId: number}> = (props) => {
          const {subscriptionId} = props ?? {};

          return  deleteApiV1SubscriptionSubscriptionId(subscriptionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1SubscriptionSubscriptionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>>

    export type DeleteApiV1SubscriptionSubscriptionIdMutationError = ProblemDetails | null

    export const useDeleteApiV1SubscriptionSubscriptionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>, TError,{subscriptionId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionId>>,
        TError,
        {subscriptionId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1SubscriptionSubscriptionIdMutationOptions(options), queryClient);
    }
    export const getApiV1SubscriptionCancellationCoupon = (

 signal?: AbortSignal
) => {


      return apiClient<GetCancellationCouponHandler | null>(
      {url: `/api/v1/subscription/cancellation-coupon`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1SubscriptionCancellationCouponQueryKey = () => {
    return [
    `/api/v1/subscription/cancellation-coupon`
    ] as const;
    }


export const getGetApiV1SubscriptionCancellationCouponQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError = ProblemDetails | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SubscriptionCancellationCouponQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>> = ({ signal }) => getApiV1SubscriptionCancellationCoupon(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SubscriptionCancellationCouponQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>>
export type GetApiV1SubscriptionCancellationCouponQueryError = ProblemDetails | null


export function useGetApiV1SubscriptionCancellationCoupon<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError = ProblemDetails | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionCancellationCoupon<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionCancellationCoupon<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SubscriptionCancellationCoupon<TData = Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionCancellationCoupon>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SubscriptionCancellationCouponQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiV1SubscriptionSubscriptionIdCancellationCoupon = (
    subscriptionId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetCancellationCouponHandler | null>(
      {url: `/api/v1/subscription/${subscriptionId}/cancellation-coupon`, method: 'PUT', signal
    },
      );
    }




export const getPutApiV1SubscriptionSubscriptionIdCancellationCouponMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>, TError,{subscriptionId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>, TError,{subscriptionId: number}, TContext> => {

const mutationKey = ['putApiV1SubscriptionSubscriptionIdCancellationCoupon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>, {subscriptionId: number}> = (props) => {
          const {subscriptionId} = props ?? {};

          return  putApiV1SubscriptionSubscriptionIdCancellationCoupon(subscriptionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1SubscriptionSubscriptionIdCancellationCouponMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>>

    export type PutApiV1SubscriptionSubscriptionIdCancellationCouponMutationError = ProblemDetails | null

    export const usePutApiV1SubscriptionSubscriptionIdCancellationCoupon = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>, TError,{subscriptionId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdCancellationCoupon>>,
        TError,
        {subscriptionId: number},
        TContext
      > => {
      return useMutation(getPutApiV1SubscriptionSubscriptionIdCancellationCouponMutationOptions(options), queryClient);
    }
    export const putApiV1SubscriptionSubscriptionIdPause = (
    subscriptionId: number,
    pauseSubscriptionRequestNull: PauseSubscriptionRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PauseSubscriptionResponse | null>(
      {url: `/api/v1/subscription/${subscriptionId}/pause`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pauseSubscriptionRequestNull, signal
    },
      );
    }




export const getPutApiV1SubscriptionSubscriptionIdPauseMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>, TError,{subscriptionId: number;data: PauseSubscriptionRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>, TError,{subscriptionId: number;data: PauseSubscriptionRequest | null}, TContext> => {

const mutationKey = ['putApiV1SubscriptionSubscriptionIdPause'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>, {subscriptionId: number;data: PauseSubscriptionRequest | null}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  putApiV1SubscriptionSubscriptionIdPause(subscriptionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1SubscriptionSubscriptionIdPauseMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>>
    export type PutApiV1SubscriptionSubscriptionIdPauseMutationBody = PauseSubscriptionRequest | null
    export type PutApiV1SubscriptionSubscriptionIdPauseMutationError = ProblemDetails | null

    export const usePutApiV1SubscriptionSubscriptionIdPause = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>, TError,{subscriptionId: number;data: PauseSubscriptionRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdPause>>,
        TError,
        {subscriptionId: number;data: PauseSubscriptionRequest | null},
        TContext
      > => {
      return useMutation(getPutApiV1SubscriptionSubscriptionIdPauseMutationOptions(options), queryClient);
    }
    export const putApiV1SubscriptionSubscriptionIdResume = (
    subscriptionId: number,
    resumeSubscriptionRequestNull: ResumeSubscriptionRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<ResumeSubscriptionResponse | null>(
      {url: `/api/v1/subscription/${subscriptionId}/resume`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resumeSubscriptionRequestNull, signal
    },
      );
    }




export const getPutApiV1SubscriptionSubscriptionIdResumeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>, TError,{subscriptionId: number;data: ResumeSubscriptionRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>, TError,{subscriptionId: number;data: ResumeSubscriptionRequest | null}, TContext> => {

const mutationKey = ['putApiV1SubscriptionSubscriptionIdResume'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>, {subscriptionId: number;data: ResumeSubscriptionRequest | null}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  putApiV1SubscriptionSubscriptionIdResume(subscriptionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1SubscriptionSubscriptionIdResumeMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>>
    export type PutApiV1SubscriptionSubscriptionIdResumeMutationBody = ResumeSubscriptionRequest | null
    export type PutApiV1SubscriptionSubscriptionIdResumeMutationError = ProblemDetails | null

    export const usePutApiV1SubscriptionSubscriptionIdResume = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>, TError,{subscriptionId: number;data: ResumeSubscriptionRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdResume>>,
        TError,
        {subscriptionId: number;data: ResumeSubscriptionRequest | null},
        TContext
      > => {
      return useMutation(getPutApiV1SubscriptionSubscriptionIdResumeMutationOptions(options), queryClient);
    }
    export const putApiV1SubscriptionSubscriptionIdDowngrade = (
    subscriptionId: number,
    scheduleDowngradeRequestNull: ScheduleDowngradeRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<ScheduleDowngradeResponse | null>(
      {url: `/api/v1/subscription/${subscriptionId}/downgrade`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleDowngradeRequestNull, signal
    },
      );
    }




export const getPutApiV1SubscriptionSubscriptionIdDowngradeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number;data: ScheduleDowngradeRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number;data: ScheduleDowngradeRequest | null}, TContext> => {

const mutationKey = ['putApiV1SubscriptionSubscriptionIdDowngrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>, {subscriptionId: number;data: ScheduleDowngradeRequest | null}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  putApiV1SubscriptionSubscriptionIdDowngrade(subscriptionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1SubscriptionSubscriptionIdDowngradeMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>>
    export type PutApiV1SubscriptionSubscriptionIdDowngradeMutationBody = ScheduleDowngradeRequest | null
    export type PutApiV1SubscriptionSubscriptionIdDowngradeMutationError = ProblemDetails | null

    export const usePutApiV1SubscriptionSubscriptionIdDowngrade = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number;data: ScheduleDowngradeRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1SubscriptionSubscriptionIdDowngrade>>,
        TError,
        {subscriptionId: number;data: ScheduleDowngradeRequest | null},
        TContext
      > => {
      return useMutation(getPutApiV1SubscriptionSubscriptionIdDowngradeMutationOptions(options), queryClient);
    }
    export const deleteApiV1SubscriptionSubscriptionIdDowngrade = (
    subscriptionId: number,
 signal?: AbortSignal
) => {


      return apiClient<CancelScheduledDowngradeResponse | null>(
      {url: `/api/v1/subscription/${subscriptionId}/downgrade`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1SubscriptionSubscriptionIdDowngradeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number}, TContext> => {

const mutationKey = ['deleteApiV1SubscriptionSubscriptionIdDowngrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>, {subscriptionId: number}> = (props) => {
          const {subscriptionId} = props ?? {};

          return  deleteApiV1SubscriptionSubscriptionIdDowngrade(subscriptionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1SubscriptionSubscriptionIdDowngradeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>>

    export type DeleteApiV1SubscriptionSubscriptionIdDowngradeMutationError = ProblemDetails | null

    export const useDeleteApiV1SubscriptionSubscriptionIdDowngrade = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>, TError,{subscriptionId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1SubscriptionSubscriptionIdDowngrade>>,
        TError,
        {subscriptionId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1SubscriptionSubscriptionIdDowngradeMutationOptions(options), queryClient);
    }
    export const getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId = (
    stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null,
 signal?: AbortSignal
) => {


      return apiClient<GetSubscriptionStripeInvoiceResponse | null>(
      {url: `/api/v1/subscription-stripe/${stripeSubscriptionId}/invoice/${stripeInvoiceId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryKey = (stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null,) => {
    return [
    `/api/v1/subscription-stripe/${stripeSubscriptionId}/invoice/${stripeInvoiceId}`
    ] as const;
    }


export const getGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError = ProblemDetails | null>(stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryKey(stripeSubscriptionId,stripeInvoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>> = ({ signal }) => getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId(stripeSubscriptionId,stripeInvoiceId, signal);





   return  { queryKey, queryFn, enabled: stripeSubscriptionId !== null && stripeSubscriptionId !== undefined && stripeInvoiceId !== null && stripeInvoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>>
export type GetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryError = ProblemDetails | null


export function useGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError = ProblemDetails | null>(
 stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError = ProblemDetails | null>(
 stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError = ProblemDetails | null>(
 stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError = ProblemDetails | null>(
 stripeSubscriptionId: string | null,
    stripeInvoiceId: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SubscriptionStripeStripeSubscriptionIdInvoiceStripeInvoiceIdQueryOptions(stripeSubscriptionId,stripeInvoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1SubscriptionStripe = (
    postSubscriptionStripeRequestNull: PostSubscriptionStripeRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PostSubscriptionStripeResponse | null>(
      {url: `/api/v1/subscription-stripe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSubscriptionStripeRequestNull, signal
    },
      );
    }




export const getPostApiV1SubscriptionStripeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>, TError,{data: PostSubscriptionStripeRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>, TError,{data: PostSubscriptionStripeRequest | null}, TContext> => {

const mutationKey = ['postApiV1SubscriptionStripe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>, {data: PostSubscriptionStripeRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1SubscriptionStripe(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1SubscriptionStripeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>>
    export type PostApiV1SubscriptionStripeMutationBody = PostSubscriptionStripeRequest | null
    export type PostApiV1SubscriptionStripeMutationError = ProblemDetails | null

    export const usePostApiV1SubscriptionStripe = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>, TError,{data: PostSubscriptionStripeRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1SubscriptionStripe>>,
        TError,
        {data: PostSubscriptionStripeRequest | null},
        TContext
      > => {
      return useMutation(getPostApiV1SubscriptionStripeMutationOptions(options), queryClient);
    }
    export const postApiV1SubscriptionStripePromotionCode = (
    postPromotionCodeRequestNull: PostPromotionCodeRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PostPromotionCodeResponse | null>(
      {url: `/api/v1/subscription-stripe/promotion-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPromotionCodeRequestNull, signal
    },
      );
    }




export const getPostApiV1SubscriptionStripePromotionCodeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>, TError,{data: PostPromotionCodeRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>, TError,{data: PostPromotionCodeRequest | null}, TContext> => {

const mutationKey = ['postApiV1SubscriptionStripePromotionCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>, {data: PostPromotionCodeRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1SubscriptionStripePromotionCode(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1SubscriptionStripePromotionCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>>
    export type PostApiV1SubscriptionStripePromotionCodeMutationBody = PostPromotionCodeRequest | null
    export type PostApiV1SubscriptionStripePromotionCodeMutationError = ProblemDetails | null

    export const usePostApiV1SubscriptionStripePromotionCode = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>, TError,{data: PostPromotionCodeRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1SubscriptionStripePromotionCode>>,
        TError,
        {data: PostPromotionCodeRequest | null},
        TContext
      > => {
      return useMutation(getPostApiV1SubscriptionStripePromotionCodeMutationOptions(options), queryClient);
    }
    export const getApiV1SubscriptionStripeProration = (
    params: GetApiV1SubscriptionStripeProrationParams,
 signal?: AbortSignal
) => {


      return apiClient<GetSubscriptionStripeProrationResponse | null>(
      {url: `/api/v1/subscription-stripe/proration`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1SubscriptionStripeProrationQueryKey = (params?: GetApiV1SubscriptionStripeProrationParams,) => {
    return [
    `/api/v1/subscription-stripe/proration`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1SubscriptionStripeProrationQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError = ProblemDetails | null>(params: GetApiV1SubscriptionStripeProrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SubscriptionStripeProrationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>> = ({ signal }) => getApiV1SubscriptionStripeProration(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SubscriptionStripeProrationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>>
export type GetApiV1SubscriptionStripeProrationQueryError = ProblemDetails | null


export function useGetApiV1SubscriptionStripeProration<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError = ProblemDetails | null>(
 params: GetApiV1SubscriptionStripeProrationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionStripeProration<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError = ProblemDetails | null>(
 params: GetApiV1SubscriptionStripeProrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SubscriptionStripeProration<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError = ProblemDetails | null>(
 params: GetApiV1SubscriptionStripeProrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SubscriptionStripeProration<TData = Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError = ProblemDetails | null>(
 params: GetApiV1SubscriptionStripeProrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SubscriptionStripeProration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SubscriptionStripeProrationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1SubscriptionStripeCoupon = (
    postCouponRequestNull: PostCouponRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PostCouponResponse | null>(
      {url: `/api/v1/subscription-stripe/coupon`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCouponRequestNull, signal
    },
      );
    }




export const getPostApiV1SubscriptionStripeCouponMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>, TError,{data: PostCouponRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>, TError,{data: PostCouponRequest | null}, TContext> => {

const mutationKey = ['postApiV1SubscriptionStripeCoupon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>, {data: PostCouponRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1SubscriptionStripeCoupon(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1SubscriptionStripeCouponMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>>
    export type PostApiV1SubscriptionStripeCouponMutationBody = PostCouponRequest | null
    export type PostApiV1SubscriptionStripeCouponMutationError = ProblemDetails | null

    export const usePostApiV1SubscriptionStripeCoupon = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>, TError,{data: PostCouponRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1SubscriptionStripeCoupon>>,
        TError,
        {data: PostCouponRequest | null},
        TContext
      > => {
      return useMutation(getPostApiV1SubscriptionStripeCouponMutationOptions(options), queryClient);
    }
    export const putApiV1SubscriptionStripeCustomerPreview = (
    putSubscriptionStripeCustomerRequestNull: PutSubscriptionStripeCustomerRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PutSubscriptionStripeCustomerResponse | null>(
      {url: `/api/v1/subscription-stripe-customer/preview`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSubscriptionStripeCustomerRequestNull, signal
    },
      );
    }




export const getPutApiV1SubscriptionStripeCustomerPreviewMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>, TError,{data: PutSubscriptionStripeCustomerRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>, TError,{data: PutSubscriptionStripeCustomerRequest | null}, TContext> => {

const mutationKey = ['putApiV1SubscriptionStripeCustomerPreview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>, {data: PutSubscriptionStripeCustomerRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  putApiV1SubscriptionStripeCustomerPreview(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1SubscriptionStripeCustomerPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>>
    export type PutApiV1SubscriptionStripeCustomerPreviewMutationBody = PutSubscriptionStripeCustomerRequest | null
    export type PutApiV1SubscriptionStripeCustomerPreviewMutationError = ProblemDetails | null

    export const usePutApiV1SubscriptionStripeCustomerPreview = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>, TError,{data: PutSubscriptionStripeCustomerRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1SubscriptionStripeCustomerPreview>>,
        TError,
        {data: PutSubscriptionStripeCustomerRequest | null},
        TContext
      > => {
      return useMutation(getPutApiV1SubscriptionStripeCustomerPreviewMutationOptions(options), queryClient);
    }
